import type { SiteSettingsState } from "./state";

export default {
  getSettings: (state: SiteSettingsState) => state.data,
};
